import { render, staticRenderFns } from "./EditInvoice.vue?vue&type=template&id=237af8d8"
import script from "./EditInvoice.vue?vue&type=script&lang=js"
export * from "./EditInvoice.vue?vue&type=script&lang=js"
import style0 from "./EditInvoice.vue?vue&type=style&index=0&id=237af8d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports